import { render, staticRenderFns } from "./OrderDataTab.vue?vue&type=template&id=b377e67c&scoped=true"
import script from "./OrderDataTab.vue?vue&type=script&lang=ts"
export * from "./OrderDataTab.vue?vue&type=script&lang=ts"
import style0 from "./OrderDataTab.vue?vue&type=style&index=0&id=b377e67c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b377e67c",
  null
  
)

export default component.exports